var _path, _path2, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _rect, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJacuzzi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.7915 19.5835H7.83317C5.67006 19.5835 3.9165 21.3371 3.9165 23.5002V31.3335C3.9165 35.6597 7.42361 39.1668 11.7498 39.1668H35.2498C39.5761 39.1668 43.0832 35.6597 43.0832 31.3335V23.5002C43.0832 21.337 41.3296 19.5835 39.1665 19.5835H21.5415",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.7915 33.2915H37.2082",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.00801,
    cy: 12.9249,
    r: 0.597292,
    stroke: "#1C1C1C",
    strokeWidth: 1.15542
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.8415,
    cy: 9.0085,
    r: 0.597292,
    stroke: "#1C1C1C",
    strokeWidth: 1.15542
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.6875,
    cy: 14.6874,
    r: 1.95833,
    stroke: "#1C1C1C",
    strokeWidth: 1.95833
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.479,
    cy: 10.771,
    r: 1.95833,
    stroke: "#1C1C1C",
    strokeWidth: 1.95833
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.1875,
    cy: 14.6874,
    r: 1.95833,
    stroke: "#1C1C1C",
    strokeWidth: 1.95833
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.633,
    cy: 16.8415,
    r: 0.597292,
    stroke: "#1C1C1C",
    strokeWidth: 1.15542
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.508,
    cy: 12.9249,
    r: 0.597292,
    stroke: "#1C1C1C",
    strokeWidth: 1.15542
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.55,
    cy: 5.0915,
    r: 0.597292,
    stroke: "#1C1C1C",
    strokeWidth: 1.15542
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.81217,
    y: 18.604,
    width: 13.7083,
    height: 7.83333,
    rx: 0.979167,
    stroke: "#1C1C1C",
    strokeWidth: 1.95833
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7083 39.1665L11.75 42.104",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2917 39.1665L35.25 42.104",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJacuzzi);
export default __webpack_public_path__ + "static/media/Jacuzzi.96e1e61a72df3249c499364fb6820063.svg";
export { ForwardRef as ReactComponent };